import { createApp } from 'vue';
import RecordingActivity from './RecordingActivity.vue';
import { i18n } from '../../i18n';

const el = document.getElementById('recording_activity');

if (el?.dataset.activity) {
  try {
    const input = JSON.parse(el.dataset.activity);
    createApp(RecordingActivity, { input }).use(i18n).mount(el);
  } catch (err) {
    console.warn('Failed to read the recording activity data:', err);
  }
}
